export default __webpack_public_path__ + "static/media/Customisation_Image.c97a6fea.png";